import React from "react";
import { connect } from "react-redux";
import { bindInstance } from "redux-mvc";

import { Div, Text3 } from "components/Base";
import { getDescription } from "Portal/Description/selectors";

import { actions } from "Portal/Description/model";

import * as R from "ramda";
import CSSModules from "react-css-modules";
import css from "./styles.scss";

const decorate = R.compose(
  connect(
    (state, props) => ({
      description: getDescription(state, props)
    }),
    bindInstance({
      toggleShowMore: actions.toggleShowMore
    })
  ),
  CSSModules(css)
);

const Description = ({ title, description, titleStyle = {} }) => {
  const { color: titleColor = null } = titleStyle || {};
  return (
    <Div>
      <Div
        mb={2}
        fw={4}
        style={{
          fontSize: "30px",
          color: titleColor || "black"
        }}
      >
        <h1
          style={{
            margin: "0 !important",
            marginTop: "0px",
            fontSize: "inherit",
            ...titleStyle
          }}
        >
          {title}
        </h1>
      </Div>
      <Text3
        mb={4}
        style={{
          color: titleColor || "black",
          maxWidth: "1050px",
          padding: "0 20px"
        }}
        className={[
          "lennd-wysiwyg-content",
          "portal-message-text",
          css.description
        ].join(" ")}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: description
          }}
          style={{
            whiteSpace: "pre-line"
          }}
        />
      </Text3>
    </Div>
  );
};

export default decorate(Description);
